module.exports = __webpack_public_path__ + "static/img/lun_7.e56b091.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lun_7.jpg
// module id = FQXi
// module chunks = 1